// extracted by mini-css-extract-plugin
export default {"fullscreenOverlay":"loader_fullscreenOverlay__Mey5+","spinnerLarge":"loader_spinnerLarge__Uw1VP"};